import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LANGUAGE_CONFIGURE } from '@meiqia/constants';
import zhProcessor from './src/zh/processor/processor.js';
import zh from './src/zh/index';
// import cht from './src/zh-TW/index';
// import en from './src/en/index';
// import th from './src/th/index';
// import vi from './src/vi/index';
// import id from './src/id/index';
// import ms from './src/ms/index';
// import hi from './src/hi/index';
// import ja from './src/ja/index';
// import pt from './src/pt/index';
// import es from './src/es/index';
// import ru from './src/ru/index';
// import ko from './src/ko/index';
// import my from './src/my/index';
// import km from './src/km/index';
// import fil from './src/fil/index';
// import fr from './src/fr/index';
// import lo from './src/lo/index';
// import nl from './src/nl/index';
// import de from './src/de/index';
// import ar from './src/ar/index';
// import bn from './src/bn/index';
// import tr from './src/tr/index';
// import fa from './src/fa/index';
// import it from './src/it/index';
// import pl from './src/pl/index';
// import zu from './src/zu/index';

const enterprise = 'meiqia';

const resources = {
  zh: {
    translation: zh
  }
  // cht: {
  //   translation: cht
  // },
  // en: {
  //   translation: en
  // },
  // th: {
  //   translation: th
  // },
  // vi: {
  //   translation: vi
  // },
  // id: {
  //   translation: id
  // },
  // ms: {
  //   translation: ms
  // },
  // hi: {
  //   translation: hi
  // },
  // ja: {
  //   translation: ja
  // },
  // pt: {
  //   translation: pt
  // },
  // es: {
  //   translation: es
  // },
  // ru: {
  //   translation: ru
  // },
  // ko: {
  //   translation: ko
  // },
  // my: {
  //   translation: my
  // },
  // km: {
  //   translation: km
  // },
  // fil: {
  //   translation: fil
  // },
  // fr: {
  //   translation: fr
  // },
  // lo: {
  //   translation: lo
  // },
  // nl: {
  //   translation: nl
  // },
  // de: {
  //   translation: de
  // },
  // ar: {
  //   translation: ar
  // },
  // bn: {
  //   translation: bn
  // },
  // tr: {
  //   translation: tr
  // },
  // fa: {
  //   translation: fa
  // },
  // it: {
  //   translation: it
  // },
  // pl: {
  //   translation: pl
  // },
  // zu: {
  //   translation: zu
  // }
};

const processorResources = {
  zh: zhProcessor
  // cht: zhProcessor,
  // en: zhProcessor,
  // th: zhProcessor,
  // vi: zhProcessor,
  // id: zhProcessor,
  // ms: zhProcessor,
  // hi: zhProcessor,
  // ja: zhProcessor,
  // pt: zhProcessor,
  // es: zhProcessor,
  // ru: zhProcessor,
  // ko: zhProcessor,
  // my: zhProcessor,
  // km: zhProcessor,
  // fil: zhProcessor,
  // fr: zhProcessor,
  // lo: zhProcessor,
  // nl: zhProcessor,
  // de: zhProcessor,
  // ar: zhProcessor,
  // bn: zhProcessor,
  // tr: zhProcessor,
  // fa: zhProcessor,
  // it: zhProcessor,
  // pl: zhProcessor,
  // zu: zhProcessor
};

const processor = {
  type: 'postProcessor',
  name: 'nameProcessor',
  process(value, key, options, translator) {
    const language = translator.language || 'zh';
    let text = value;
    try {
      const processJson = processorResources[language][enterprise];
      if (processJson && key && processJson[key[0]]) {
        text = processJson[key[0]].replace(/\{\{(\S+?)\}\}/g, (all, val) => {
          return options[val] || val;
        });
      } else return text;
    } catch (e) {
      throw new Error(`error =>>>>>>>>>>>${e}`);
    }

    return text;
  }
};

export const currentLanguage = () => {
  const languageList = LANGUAGE_CONFIGURE.LANGUAGE_CONFIGURE;
  const currentLanguage = localStorage.getItem('current_language') ?? languageList[0].label;
  const currentLanguageValue = languageList.find(language => language.label === currentLanguage).value;
  // 其它项目直接从 localStorage 中获取 language_config
  const languageConfig =
    localStorage.getItem('language_config') ??
    JSON.stringify({
      name: currentLanguage,
      code: currentLanguageValue
    });
  localStorage.setItem('language_config', languageConfig);
  return currentLanguageValue;
};

i18n
  .use(processor)
  .use(initReactI18next)
  .init({
    resources,
    debug: false,
    lng: currentLanguage(),
    fallbackLng: 'zh',
    postProcess: ['nameProcessor'],
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true
    },
    keySeparator: '::'
  });

export default i18n;
